import { useDeleteUndo } from './useDeleteUndo';

export function DeleteUndo({ undo }: { undo: ReturnType<typeof useDeleteUndo> }) {
  return <div className="undo-queue" aria-live="polite">{undo.items.map((item) => <div className="alert success undo-item" key={item.key}><span>{item.error || `「${item.label}」${item.ids.length > 1 ? `ほか${item.ids.length - 1}件` : ''}を削除しました`}</span><button className="button secondary" disabled={item.busy} onClick={() => void undo.restore(item.key)}>{item.busy ? '戻しています…' : '元に戻す'}</button></div>)}</div>;
}
